<template>
  <div class="container">
    <div class="col-md-12">
      <ObjectDataList :objectSchema="objectSchema" :objectModel="objectModel"/>
    </div>
  </div>
</template>

<script>

import ObjectDataList from './ObjectDataList'

export default {
  components: {
    ObjectDataList
  },
  name: 'ObjectDataManagement',
  data () {
    return {
      objectModel: {},
      objectSchema: {},
      objectDataId: 10,
      objectDescription: {}
    }
  },
  mounted () {
    this.$http
      .get('/api/objectdescriptions/objectgroupid/' + this.objectDataId)
      .then(response => {
        this.objectDescription = response.data[0]
        this.objectModel = JSON.parse(response.data[0].model)
        this.objectSchema = JSON.parse(response.data[0].schema)
      })
      .catch(error => console.log(error))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectData/ObjectDataManagement.vue